import axios from "../../privateApi";

interface CheckoutSessionOptions {
  priceId?: string;
  discountId?: string;
  promoCode?: string;
  freeTrial?: number;
}

export const createCheckoutSession = async ({
  priceId,
  discountId,
  promoCode,
  freeTrial,
}: CheckoutSessionOptions) => {
  const body = {
    priceId,
    discountId,
    freeTrial,
    promoCode,
    refId: window.Rewardful?.referral,
  };

  return axios
    .post("/payments/create-checkout-session", body)
    .then((response) => {
      const redirected = response.data.status === 303;
      if (redirected) window.location.href = response.data.url;
      return redirected;
    });
};
